import script from "./FindPhysicianModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FindPhysicianModal.vue?vue&type=script&setup=true&lang=js"

import "./FindPhysicianModal.vue?vue&type=style&index=0&id=66e2808a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e2808a"]])

export default __exports__